module.exports = __webpack_public_path__ + "static/media/r-md11.de141d47.png";